const INTERNAL_RENDER_PATH =
  /^\/internal\/render-(?:report\/[^/]+|legacy-reconstruction\/[^/]+|billing-report\/(?:cpt-frequency|specimen-log|accession-log|corrections)|tc-technical-summary\/[^/]+)$/;

let bootstrapToken: string | null = null;

export function isInternalRenderPath(
  pathname = typeof window === "undefined" ? "" : window.location.pathname
): boolean {
  return INTERNAL_RENDER_PATH.test(pathname);
}

export function parseInternalRenderToken(hash: string): string | null {
  const token = new URLSearchParams(hash.replace(/^#/, "")).get("t");
  return token?.trim() || null;
}

function consumeInternalRenderLocation(): void {
  if (typeof window === "undefined" || !isInternalRenderPath()) return;

  bootstrapToken = parseInternalRenderToken(window.location.hash);
  if (!window.location.hash) return;

  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}${window.location.search}`
  );
}

consumeInternalRenderLocation();

export function getInternalRenderBootstrapToken(): string | null {
  return bootstrapToken;
}

export function clearInternalRenderBootstrapToken(): void {
  bootstrapToken = null;
}
